import OliverText from "@builder/components/general/OliverText";
import { setSpecialLayers } from "@builder/store/slices/BuilderSlice/builderSlice";
import { useAppDispatch } from "@builder/store/store";
import { BaseLayerTypes } from "@common/build/types";
import ContextMenuWrapper from "./LogicalWrapper/ContextMenuWrapper";
import "./style.scss";

const ContextMenuPages = ({
    targetRef,
    pageID,
    stateSelectedElement,
    type
}: {
    targetRef: React.RefObject<HTMLDivElement>;
    pageID: string;
    stateSelectedElement?: (state: boolean) => void;
    type?: BaseLayerTypes;
}) => {
    const dispatch = useAppDispatch();

    const setAsHomePage = () => {
        dispatch(
            setSpecialLayers({
                homepage: {
                    id: pageID,
                    name: "Home",
                    type: BaseLayerTypes.PAGES
                }
            })
        );
    };

    const setAsBaseLayerHomepage = () => {
        dispatch(
            setSpecialLayers({
                customerDisplayHomepage: {
                    id: pageID,
                    name: "Home",
                    type: BaseLayerTypes.CFDS
                }
            })
        );
    };

    const clientRect = targetRef.current?.getBoundingClientRect();

    return (
        <ContextMenuWrapper
            targetRef={targetRef}
            className="context-menu-wrapepr"
            setStateSelectedElement={stateSelectedElement}
            specificPosition={
                clientRect
                    ? {
                          top: clientRect.top + clientRect.height / 2 + 5
                      }
                    : undefined
            }
        >
            <menu className="pages-menu">
                <div className="single-item" onClick={type === BaseLayerTypes.PAGES ? setAsHomePage : setAsBaseLayerHomepage}>
                    <img src="./home-icon.svg" />
                    <div className="texts">
                        <OliverText
                            text={type === BaseLayerTypes.PAGES ? "Set as home" : "Set as default customer display"}
                            size="xs"
                            translatePrefix="contextMenu."
                        />
                        <OliverText
                            text={
                                type === BaseLayerTypes.PAGES
                                    ? "Home page is the first screen of your build"
                                    : "Default customer display will be the first screen displayed on the customer facing display"
                            }
                            size="xxs"
                            translatePrefix="contextMenu."
                            color="base-grey"
                        />
                    </div>
                </div>
            </menu>
        </ContextMenuWrapper>
    );
};

export default ContextMenuPages;
